import React, { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@doger/ui/components/ui/button';
import { $$api } from '@doger/core/shared/api';

import styles from './access-denied.module.scss';

export const AppAccessDenied = memo(() => {
  const navigate = useNavigate();

  useEffect(() => {
    $$api.tokensService.removeTokens();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Access Denied</h1>
        <p className={styles.message}>
          You don't have permission to access the admin panel. Only
          administrators can view this area.
        </p>
        <div className={styles.actions}>
          <Button
            size='lg'
            variant='contained'
            palette='primary'
            onClick={() => {
              navigate('/sign-in');
            }}
          >
            Sign In as Admin
          </Button>
        </div>
      </div>
    </div>
  );
});
